<template>
  <table-layout title="سطل زباله دوره ها" :showSearch="false">
    <template #buttons>

      <router-link :to="{ name: 'CoursesDashboard' }" class="ml-2">
        <b-button pill variant="purple">  بازگشت به صفحه دوره‌ها </b-button>
      </router-link>
    </template>
    <template #table>
        <course-items :items="TrashCourses" :restoreState="true" ></course-items>
    </template>
  </table-layout>
</template>

<script>
import courseItems from './courseItems.vue';
import TableLayout from "../TableLayout.vue";
import { tableAttributes } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import { mapGetters } from "vuex";
export default {
  name: "trashItems",
  components:{TableLayout,courseItems},
  data() {
    return {
      tableAttributes,
    };
  },
  methods: {

  },
  computed: {
    ...mapGetters({
      TrashCourses: "Course/getTrash",
    }),
  },
  mounted(){
      this.$store.dispatch("Course/getTrash");
  }
};
</script>